import React, { useState, useEffect, useRef } from 'react';
import {useNavigate} from 'react-router-dom';
import {Box} from '@mui/material';
import * as allConstants from '../../../../../constants/allConstants';
import AllInspectionsGrid from './allInspectionsGrid';
import ModalWrapper from '../../../../../pieces/modals/modalWrapper';
import DisplayListsPageWrapper from '../../../../wrappers/displayListsPageWrapper';
import {globalUseClasses} from '../../../../../styles/globalClasses';
import ListPageHeader from '../../../../../pieces/listPageHeader';
import usePagination from '../../../../../hooks/usePagination';
import mergeProps from 'merge-props';
import {useGridViewState} from '../../../../../hooks/useGridViewState';
import clsx from 'clsx';
import {jobFilters} from '../../../allJobs/jobExtendedFilters';
import {useSelector} from 'react-redux';
import {GridWithFilterWrapper, useFilter} from '../../../../../hooks/useFilter';
import useViewMenu, {MenuOption} from '../../../../../hooks/useViewMenu';
import {inspectionApiTypes} from './inspectionsGridOptions';
import {ListViewHeader} from '../../../components/listViewHeader';
import ManageCustomViews from '../../../components/manageCustomViews';
//import {isContractor} from '../../../../../permissions/utils';
//import { propsToClassKey } from '@mui/styles';
//import { stubFalse } from 'lodash';

/**
 * `lockedView` ({value, title, heading}) pins the grid to that one view: the menu holds only it,
 * which also hides the view dropdown. The AI dashboard's Needs Attention tab is the Verify view
 * this way.
 *
 * `title` must stay the view's menu title: saved custom views are looked up by it (`origView`), so
 * changing it hides them. `heading` is what the header shows instead, when the two differ.
 */
const AllInspectionsView = ({suppressNavTopPadding = false, fromAiDashboard = false, lockedView = null} = {}) => {

  //console.log('inside AllInspectionsView');
  

  //const [createdFromDate, setCreatedFromDate] = useState();
  //const [globalFilters, setGlobalFilters] = useState({});
  const [globalSearchFilters, setGlobalSearchFilters] = useState({});

  const [crudAction, setCrudAction] = useState('');
  const [isCategory, setIsCategory] = useState(false);
  const [customViewVisible, setCustomViewVisible] = useState(false);

  const viewController = useGridViewState();
  const navigate = useNavigate();
  const classes = {...globalUseClasses()};
  const pagination = usePagination();
  const user = useSelector(state=> state.user);

  const filterFields = jobFilters.getFilters(user, {module: allConstants.IPERMIT_MODULES.INSPECTION});


  // useEffect ( () => {

  //   if (!isContractor(user[allConstants.USER_FIELDS.ROLE.api_name])) {
  //     const oneYearAgo = new Date();
  //     oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  //     //oneYearAgo.setMonth(oneYearAgo.getMonth() - 6);

  //     setCreatedFromDate(oneYearAgo.toISOString().split('T')[0]);

  //     const filters = {"createdAt":{"dateFrom": oneYearAgo.toISOString().split('T')[0] ,"dateTo":null,"filterType":"date","type":"greaterThanOrEqual"}};
  //     setGlobalFilters(filters);
  //     viewController.setGlobalFilters(filters);
  //   }
    
  // },[]);
  
  const getMenuItems = ()=> {

    if (lockedView) {
      return [new MenuOption(lockedView.value, lockedView.title)];
    }

    if (fromAiDashboard) {

      /**
       * No Verify view here: it is the dashboard's Needs Attention tab. Listing it in both places
       * would also let that tab's `view` search param, which this menu reads on mount, reopen
       * All Inspections on Verify instead of its default.
       */
      return [
        //new MenuOption(inspectionApiTypes.aiReady, 'Ready for AI Calls'),
        new MenuOption(inspectionApiTypes.aiInProgress, 'In Progress AI Calls'),
        new MenuOption(inspectionApiTypes.aiRescheduled, 'Rescheduled AI Calls'),
        new MenuOption(inspectionApiTypes.aiClosedOut, 'Closed Out AI Calls'),
        new MenuOption(inspectionApiTypes.aiAll, 'All AI Calls'),
      ];
    }
    else {
      return [
        new MenuOption(inspectionApiTypes.pending, 'Pending Inspections'),
        new MenuOption(inspectionApiTypes.all, 'All Inspections'),
        new MenuOption(inspectionApiTypes.previous, 'Follow up'),
        new MenuOption(inspectionApiTypes.manual, 'Manually Ordered Inspections'),
        new MenuOption(inspectionApiTypes.hold, 'Hold'),
        new MenuOption(inspectionApiTypes.completed, 'Completed'),
        new MenuOption(inspectionApiTypes.failed, 'Failed'),
        new MenuOption(inspectionApiTypes.futureDate, 'Future Date'),
        new MenuOption(inspectionApiTypes.report, 'Report for Export'),
      ];
    }
  };

  const InspectionsGridEnum = getMenuItems();

  const defaultMenuIndex = Math.max(
    0,
    InspectionsGridEnum.findIndex((opt) =>
      opt.value === (fromAiDashboard ? inspectionApiTypes.aiInProgress : inspectionApiTypes.pending),
    ),
  );

  const menuController = useViewMenu({items: InspectionsGridEnum, initialViewGrid: defaultMenuIndex});

  const extendedFilters = useFilter({fields: filterFields, width: 230, collection: 'jobs'});

  const viewJobHandler = (id)=> {

    let newPath = location.pathname;
    let newSearch = location.search;
    if (fromAiDashboard) {
      newPath = newPath.replace('ai-dashboard', 'module');
      const searchParams = new URLSearchParams(newSearch);
      searchParams.delete('view');
      searchParams.delete('moduleName');
      searchParams.set('moduleName', 'inspection');
      newSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';
    }
    const url = `${location.origin}${newPath}/${id}${newSearch}&showSameAddressJobs=true`;
    window.open(url, '_blank');
  };


  const gridProps = {
    viewJobHandler: viewJobHandler,
    pagination: pagination,
    viewController: viewController
  };

  const handleClick = (event) => {
    menuController.setAnchorEl(event.currentTarget);
  };

  const showCustomView = (customView, crudAction, isCategory = false) => {

    setIsCategory(isCategory);
    setCrudAction(crudAction);
    customView.extendedFilter = JSON.stringify(extendedFilters.applyFilters);
  
    viewController.UpdateCustomViewFilterAndSorting(customView);
    setCustomViewVisible(true);
  };

  const setNewCustomViewId = (viewId) =>{
    viewController.setNewCustomViewId(viewId);
  }

  const changeCurrentView = (customView) => {
    if (customView) {
      if (customView?.extendedFilter != "") {
        extendedFilters.setApplyFilters(JSON.parse(customView.extendedFilter));
      }  
    }
    else {
      extendedFilters.setApplyFilters({});
    }

    viewController.changeCurrentView(customView);
  };

  const closeCustomView = () => {
    setCustomViewVisible(false);
  }

  // const createdFromDateChange = (newDate) => {
  //   setCreatedFromDate(newDate);
  // };

  const turnOffSearch = () => {
    setGlobalSearchFilters({});

    //globalSearchFiltersRef3.current = {};

  };

  const createFilterForSearchText = (searchText) => {
 
    const minJobNum = 1000000;
    let jobNum =  (/^\d+$/.test(searchText)) ? parseInt(searchText) : minJobNum;

    if (jobNum < minJobNum) 
      jobNum = minJobNum;

    const filters = {"homeOwner.firstName": {"filterType":"text","type":"contains","filter": searchText}, 
                "company.name": {"filterType":"text","type":"contains","filter": searchText},
                jobNumber: {"filterType":"number","type":"equals","filter": jobNum},
                "address.line1": {"filterType":"text","type":"contains","filter": searchText},
                "assignedCity.name": {"filterType":"text","type":"contains","filter": searchText},
                serviceTitanJobNumber: {"filterType":"text","type":"contains","filter": searchText},
                "duplicateOf": {"filterType":"number","type":"equals","filter": jobNum},
              };
// Last note (Not mandatory if hard)

    setGlobalSearchFilters(filters);

    //globalSearchFiltersRef3.current = filters;

  }

  // useEffect ( () => {

  //   //console.log('inside useEffect - createdFromDate changed');

  //   if (!isContractor(user[allConstants.USER_FIELDS.ROLE.api_name])) {
  //     const filters = {"createdAt":{"dateFrom": createdFromDate ,"dateTo":null,"filterType":"date","type":"greaterThanOrEqual"}};
  //     setGlobalFilters(filters);
  //     viewController.setGlobalFilters(filters);

  //     //console.log('new global filter');
  //     //console.log(filters);

  //   }


  // }, [createdFromDate])

  // useEffect ( () => {

  //     console.log('new global filter');
  //     console.log(globalFilters);

  //   refreshGrid();
  // }, [globalFilters])

  const refreshGrid = () => {
    viewController.refreshGrid();
  };

  const getAdditionalButtons = () => {
    return [
      {
        key: 1,
        label: `Refresh Grid`,
        variant: 'outlined',
        color: 'primary',
        onClick: refreshGrid,
      },
    ];
  };

  const getHeaderComponent = ()=> {
    let title = lockedView?.heading || menuController.title;
    if(pagination?.totalItemsCount || pagination.totalItemsCount === 0) {
      title = `${title} (${pagination.totalItemsCount})`;
    }
    return (
      <ListViewHeader title={title}
        gridEnum={InspectionsGridEnum}
        // createdFromDate={createdFromDate}
        // createdFromDateChange={createdFromDateChange}
        pagination={pagination}
        handleClick={handleClick}
        menuController={menuController}
        extendedFilters={extendedFilters}
        viewController={viewController}
        showCustomView={showCustomView}
        changeCurrentView = {changeCurrentView}
        sendEmail={true}
        totalItemsCount={pagination.totalItemsCount}
      />
    );
  };

  const headerComponent = <ListPageHeader headComponent = {getHeaderComponent()}
    viewController={viewController}
    extendedFilters={extendedFilters}
    totalItems={pagination.totalItemsCount}
    addHandler={()=>{navigate(allConstants.PATH.CREATE_JOB);}}
    showAddButton={false}
    additionalButtons={getAdditionalButtons()}
    showCustomView={true} 
    createFilterForSearchText={createFilterForSearchText}
    turnOffSearch={turnOffSearch}
  >
    {pagination.ItemsController}
  </ListPageHeader>;

  const currGridProps = mergeProps(gridProps, {gridType: InspectionsGridEnum[menuController.viewGrid].value});
  
  return (
    <>
      <Box
        className={clsx(!suppressNavTopPadding && classes.page)}
        sx={suppressNavTopPadding ? {height: '100%'} : undefined}
      >
        {customViewVisible && 
          <ModalWrapper
            open={true} modalName={'custom-view'}
            customStyle = {{minHeight: '50%'}}
            preventScroll={true}
            width={'50%'}
          >
            <ManageCustomViews closeCustomView = {closeCustomView} customViewData={viewController.customViewData}  
                      crudAction={crudAction} isCategory={isCategory} setNewCustomViewId={setNewCustomViewId} />
          </ModalWrapper>
        }
        <DisplayListsPageWrapper
          headerComponent={headerComponent}>

          <GridWithFilterWrapper show={extendedFilters.show} filterPanel={extendedFilters.filterPanel}>
            {
              <AllInspectionsGrid
                {...currGridProps}
                key={InspectionsGridEnum[menuController.viewGrid].value}
                additionalFilters={extendedFilters.applyFilters}
                containedLoader={fromAiDashboard}
                //globalFilters={globalFilters}
                globalSearchFilters={globalSearchFilters}

              />
            }
          </GridWithFilterWrapper>
          {pagination.PageController}
        </DisplayListsPageWrapper>

      </Box>

    </>


  );
};

export default AllInspectionsView;
